"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBankingAccountLoadPending = exports.getAccountLoadPending = exports.getInvestmentLoadPending = exports.getAccountStore = void 0;
const reducer_1 = require("./reducer");
const getAccountStore = (state) => state[reducer_1.ACCOUNTS_REDUCER_KEY];
exports.getAccountStore = getAccountStore;
const getInvestmentLoadPending = (state) => (0, exports.getAccountStore)(state).isInvestmentAccountsLoading;
exports.getInvestmentLoadPending = getInvestmentLoadPending;
const getAccountLoadPending = (state) => {
    const accountStore = (0, exports.getAccountStore)(state);
    return accountStore.isInvestmentAccountsLoading && accountStore.isLoading && accountStore.loadPending;
};
exports.getAccountLoadPending = getAccountLoadPending;
const getBankingAccountLoadPending = (state) => {
    const accountStore = (0, exports.getAccountStore)(state);
    return accountStore.isLoading && accountStore.loadPending;
};
exports.getBankingAccountLoadPending = getBankingAccountLoadPending;
